import { CL } from './settingsCL';
import { MX } from './settingsMX';
// eslint-disable-next-line import/prefer-default-export
export const settings = {
  CL,
  MX,
};
